interface ComputerWithSchemeSVGProps {
  color: string;
  style: React.CSSProperties;
}

const ComputerWithSchemeSVG = ({
  color,
  style,
}: ComputerWithSchemeSVGProps) => (
  <svg
    style={style}
    xmlns="http://www.w3.org/2000/svg"
    width="45"
    height="50"
    viewBox="0 0 45 50"
    fill="none"
  >
    <g clipPath="url(#clip0_519_19434)">
      <path
        d="M40.2725 0.556641C42.0131 0.556641 43.4255 1.96901 43.4255 3.70961V28.8439C43.4255 30.5845 42.0131 31.9969 40.2725 31.9969H4.21718C2.47658 31.9969 1.06421 30.5845 1.06421 28.8439V3.70961C1.06421 1.96901 2.47658 0.556641 4.21718 0.556641C5.42068 0.556641 41.3666 0.556641 40.2725 0.556641Z"
        stroke={color}
        strokeWidth="1.12"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.4384 32.0068L9.50879 36.8706H22.24H34.9713L33.0517 32.0068"
        stroke={color}
        strokeWidth="1.12"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M40.0538 40.5605L43.7438 47.2146C44.3008 48.2192 43.5747 49.4426 42.4309 49.4426H2.05894C0.915113 49.4426 0.189034 48.2192 0.746026 47.2146L4.4361 40.5605H40.0637H40.0538Z"
        stroke={color}
        strokeWidth="1.12"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.1665 24.5374V10.543H24.9851V24.5374"
        stroke={color}
        strokeWidth="1.12"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.3855 24.4677V16.998H12.2041V24.6169"
        stroke={color}
        strokeWidth="1.12"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M31.9475 24.6169V16.998H37.7661V24.4677"
        stroke={color}
        strokeWidth="1.12"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.1896 11.7464C11.1896 12.7908 10.3442 13.6462 9.28988 13.6462C8.23557 13.6462 7.39014 12.8007 7.39014 11.7464C7.39014 10.6921 8.23557 9.84668 9.28988 9.84668C10.3442 9.84668 11.1896 10.6921 11.1896 11.7464Z"
        stroke={color}
        strokeWidth="1.12"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M36.7614 11.7464C36.7614 12.7908 35.916 13.6462 34.8617 13.6462C33.8073 13.6462 32.9619 12.8007 32.9619 11.7464C32.9619 10.6921 33.8073 9.84668 34.8617 9.84668C35.916 9.84668 36.7614 10.6921 36.7614 11.7464Z"
        stroke={color}
        strokeWidth="1.12"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23.9804 5.29134C23.9804 6.3357 23.135 7.19108 22.0806 7.19108C21.0263 7.19108 20.1809 6.34565 20.1809 5.29134C20.1809 4.23704 21.0263 3.3916 22.0806 3.3916C23.135 3.3916 23.9804 4.23704 23.9804 5.29134Z"
        stroke={color}
        strokeWidth="1.12"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23.7219 6.24609L33.2206 10.7915"
        stroke={color}
        strokeWidth="1.12"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.9309 10.7915L20.4396 6.24609"
        stroke={color}
        strokeWidth="1.12"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.93872 24.6172H40.5411"
        stroke={color}
        strokeWidth="1.12"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_519_19434">
        <rect width="44.4898" height="50" fill={color} />
      </clipPath>
    </defs>
  </svg>
);

export default ComputerWithSchemeSVG;
